import {ConstantsContainer} from "../helper/constants";
import axios from "axios";

export const createPaymentApi = (token, accessToken,transactionIndex, truncatedPan, expiryDate, cvv, cardBin, threeDSecureProtocolVersion,
                                 threeDSecureCardHolderAuthenticationId, threeDSecureCardHolderAuthenticationData, threeDSecureElectronicCommerceIndicator,
                                 threeDSecureTransactionId, hiddenToken, cardholderName) => {
    const createPaymentUrl = `${ConstantsContainer.hellopayBaseUrl}${ConstantsContainer.createPaymentEndpoint}`;

    const request = {
        payment_token: token,
        card_token: transactionIndex,
        truncated_pan: truncatedPan,
        expiry_date: `${expiryDate.replace('/', '')}`,
        cvv: cvv,
        card_bin: cardBin,
        payment_type: "Capture",
        three_ds_protocol_version: threeDSecureProtocolVersion,
        three_ds_cardholder_authentication_id: threeDSecureCardHolderAuthenticationId,
        three_ds_cardholder_authentication_data: threeDSecureCardHolderAuthenticationData,
        three_ds_electronic_commerce_indicator: threeDSecureElectronicCommerceIndicator,
        three_ds_transaction_id: threeDSecureTransactionId,
        cardholder_name: cardholderName
    };

    return axios.post(createPaymentUrl, request, {
        mode: "cors",
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'hidden-token' : hiddenToken,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':'Origin, X-Api-Key, X-Requested-With, Content-Type, Accept, Authorization',
            'Content-type': 'application/json; charset=UTF-8',
            'Accept': 'application/json; charset=UTF-8'
        },
    }).then((response) => {
        return response;
    })
        .catch((error) => {
            return error;
        })
}